import classNames from 'classnames'
import React, {useRef, useState} from 'react'

import useOnDocumentMousedown from '../../hooks/useOnDocumentMousedown'

import {NavToggleContent} from './NavToggleContent'

interface NavToggleProps {
  data: {
    href: string
    marketingText: string
    title: string
    toSpa: boolean
    dropdown?: []
    hasDivider?: boolean
  }
  modifier: string
}

export const NavToggle: React.FC<NavToggleProps> = ({data, modifier}) => {
  const node = useRef<HTMLLIElement>(null)
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const handleDocumentClick = (event: React.MouseEvent<HTMLLIElement>) => {
    const currentNode = node.current
    if (isDropdownOpen && !currentNode?.contains(event.target as Node)) {
      setIsDropdownOpen(false)
    }
  }

  useOnDocumentMousedown(handleDocumentClick)

  const classes = classNames('c-nav__item', {
    'c-nav__item--has-dropdown': data.dropdown,
    'c-nav__item--has-divider': data.hasDivider,
    'c-nav__item--is-open': isDropdownOpen,
    [`c-nav__item--${modifier}`]: modifier,
  })

  return (
    <li className={classes} ref={node}>
      <NavToggleContent data={data} />
    </li>
  )
}
